<template>
    <v-sheet ref="wrapper">
        <template v-if="isPreview">
            <div class="mb-40" style="height: 56px">
                <div :style="style_alert">
                    <v-alert text icon="mdi-information-outline" color="info" rounded class="mb-40">
                        <span> 미리보기 화면입니다 </span>
                    </v-alert>
                </div>
            </div>
        </template>
        <template v-else-if="!program.isGranted">
            <div class="mb-40" style="height: 56px">
                <div :style="style_alert">
                    <v-alert text icon="mdi-alert-outline" color="red" rounded class="mb-40">
                        <span> 승인되지 않은 프로그램입니다 </span>
                    </v-alert>
                </div>
            </div>
        </template>
        <v-row class="ma-n20">
            <v-col order="2" order-lg="1" cols="12" lg="" class="pa-20">
                <view-body v-bind="{ program, isPreview }" />
            </v-col>
            <v-col order="1" order-lg="2" cols="12" lg="auto" class="pa-20" v-bind="{ style: style_headCol }">
                <view-head
                    v-bind="{
                        program,
                        isPreview,
                        style: style_head,
                    }"
                />
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import { initExpoProgram } from "@/assets/variables";

import ViewBody from "./view/view-body.vue";
import ViewHead from "./view/view-head.vue";

export default {
    components: {
        ViewBody,
        ViewHead,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
        isPreview: { type: Boolean, default: false },
    },
    data: () => ({
        width_wrapper: 1200,
    }),
    computed: {
        ...mapState("ui", {
            innerWidth: (store) => store.window.innerWidth,
            scrollY: (store) => store.window.scrollY,
        }),
        style_alert() {
            let style = {
                position: this.innerWidth < 1024 ? undefined : "fixed",
                top: this.innerWidth < 1024 ? undefined : "124px",
                width: `${this.width_wrapper}px`,
                zIndex: 1000,
                background: "white",
            };

            if (this.scrollY < 100) {
                delete style.position;
                delete style.top;
            }

            if (this.isPreview && !(this.innerWidth < 1024)) {
                style.position = "fixed";
            }

            return style;
        },
        style_head() {
            let style = {
                width: this.innerWidth < 1024 ? undefined : "388px",
                position: this.innerWidth < 1024 ? undefined : "fixed",
                top: this.innerWidth < 1024 ? undefined : "124px",
            };

            if (this.scrollY < 100) {
                delete style.position;
                delete style.top;
            }

            if (this.isPreview && !(this.innerWidth < 1024)) {
                style.position = "fixed";
                delete style.top;
            }

            if (style.top && this.isPreview) {
                style.top = "96px";
            }

            if (style.top && !this.program.isGranted) {
                style.top = "220px";
            }

            return style;
        },
        style_headCol() {
            return {
                width: this.innerWidth < 1024 ? undefined : "428px",
            };
        },
    },
    methods: {
        init() {
            window.addEventListener("resize", this.setSize);
            this.setSize();
        },
        setSize() {
            const intervalId = setInterval(() => {
                const { $el } = this.$refs["wrapper"] || {};
                if (!$el) return;

                this.width_wrapper = $el.getClientRects()[0].width;
                clearInterval(intervalId);
            }, 10);
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setSize);
    },
};
</script>

<style>
</style>